import React, { useEffect, useState } from "react";
import { KeyRound, Loader2 } from "lucide-react";
import api from "@/lib/api";
import { Card } from "@/components/common";

const STATUS = {
  konfiguriert: { label: "Konfiguriert", cls: "bg-[#A3E635]/15 text-[#A3E635] border-[#A3E635]/30" },
  fehlt: { label: "Fehlt", cls: "bg-amber-400/10 text-amber-300 border-amber-400/30" },
  konflikt: { label: "Konflikt", cls: "bg-red-500/15 text-red-300 border-red-500/30" },
};
const ACCOUNT = { vorhanden: "Konto vorhanden", fehlt: "Konto fehlt", keine_adresse: "Keine Adresse" };
const ROLE = { super_admin: "Super Admin", admin_ops: "Admin Ops" };
const SOURCE = (s, t) => (!s ? "—" : s === "standard" ? t("Standardadresse") : s);

export function AccountConfigCard({ t }) {
  const [data, setData] = useState(null);
  const [error, setError] = useState(false);
  useEffect(() => {
    api.get("/admin/security/account-config").then((r) => setData(r.data)).catch(() => setError(true));
  }, []);

  return (
    <Card className="p-5" data-testid="sec-account-config-card">
      <div className="flex items-center gap-2 text-[11px] font-bold uppercase tracking-[0.16em] text-gray-400 mb-1"><KeyRound className="w-4 h-4 text-[#A3E635]" /> {t("Konto-Schlüssel")}</div>
      <p className="text-[11px] text-gray-500 mb-3" data-testid="account-config-hint">{t("Nur Status, nie Werte. Kein Nachweis eines erfolgreichen Logins.")}</p>
      {error && <p className="text-sm text-red-300" data-testid="account-config-error">{t("Status konnte nicht geladen werden.")}</p>}
      {!data && !error && <Loader2 className="w-5 h-5 animate-spin text-[#A3E635]" data-testid="account-config-loading" />}
      <div className="space-y-3">
        {(data?.entries || []).map((e) => (
          <div key={e.keys[0].key} className="border-b border-white/5 last:border-0 pb-3 last:pb-0" data-testid={`account-config-${e.role}-${e.keys[1].key}`}>
            <div className="flex items-center justify-between gap-2">
              <span className="text-sm font-semibold truncate">{e.person.replace(/ \(.*\)$/, "")}</span>
              <span className="text-[10px] font-semibold text-gray-400 shrink-0" data-testid="account-config-role">{ROLE[e.role] || e.role}</span>
            </div>
            <div className="text-[11px] text-gray-500 truncate" data-testid="account-config-identity">{e.identity ? `${e.identity} · ${t(ACCOUNT[e.account] || e.account)}` : t("Keine Adresse")}</div>
            {e.keys.map((k) => { const s = STATUS[k.status] || STATUS.fehlt; return (
              <div key={k.key} className="flex items-center justify-between gap-2 mt-1.5" data-testid={`account-key-${k.key}`}>
                <div className="min-w-0">
                  <div className="text-[11px] font-mono text-gray-300 truncate">{k.key}</div>
                  <div className="text-[10px] text-gray-500 truncate">{t("Quelle")}: {SOURCE(k.source, t)}</div>
                </div>
                <span className={`text-[10px] font-bold px-2 py-0.5 rounded-full border shrink-0 ${s.cls}`} data-testid={`account-key-status-${k.key}`}>{t(s.label)}</span>
              </div>
            ); })}
            {(e.conflicts || []).map((c, i) => <div key={i} className="text-[10px] text-red-300 mt-1" data-testid="account-config-conflict">{c}</div>)}
          </div>
        ))}
      </div>
    </Card>
  );
}
